/* eslint-disable no-undef */

import lazyLoad from './modules/lazyLoad';
import headerFixed from './modules/headerFixed';
import map from './modules/map';
import menu from './modules/menu';
import form from './modules/form';
import popup from './modules/popup';
import services from './modules/services';
import scrollHelp from './modules/scrollHelp';
import animate from './modules/animate';
import examples from './modules/examples';
import documents from './modules/documents';
import steps from './modules/steps';
import throttle from './utils/throttle';

$(document).ready(() => {
  GLightbox();
  svg4everybody();
  lazyLoad();
  headerFixed();
  map();
  menu();
  form();
  popup();
  services();
  scrollHelp();
  animate();
  examples();
  documents();
  steps();
  $('[name=Телефон]').mask('+7 (999) 999-99-99?9', { placeholder: '+7 (___) ___-__-__ ' });

  if (window.matchMedia('(min-width: 1200px)').matches) {
    $('.my-paroller').paroller();
  }

  $(window).on('resize', throttle(() => {
    examples();
  }, 200));
});
